module.exports = __webpack_public_path__ + "static/media/icon_monotributista_active.87d528c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_monotributista_active.svg
// module id = 334
// module chunks = 0